import React, { useEffect } from 'react';
import { apiCaller } from '../../hooks/useApi';
import { ServiceAgent } from '../../services/serviceAgent';
import { useAuth } from '../../../modules/auth';

declare global {
  interface Window {
    NAJVA?: {
      getUserToken: () => Promise<string>;
    };
  }
}

const PushContext = React.createContext({});

function waitForNajva(): Promise<typeof window.NAJVA> {
  return new Promise((resolve) => {
    const checkInterval = setInterval(() => {
      if (window.NAJVA) {
        clearInterval(checkInterval);
        resolve(window.NAJVA);
      }
    }, 100);
  });
}

const PushContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { userInfo, jwtToken } = useAuth();

  useEffect(() => {
    const getUserId = async () => {
      try {
        const najva = await waitForNajva();
        if (!najva) {
          console.warn('Najva not loaded');
          return;
        }

        const dataId = await najva.getUserToken();

        if (userInfo?.deviceId !== dataId && jwtToken && userInfo) {
          if(dataId) {
            apiCaller({
              api: ServiceAgent.user.request_adduserposhetoken,
              apiArguments: {
                deviceId: dataId
              },
              onSuccess: (resp) => {
                if (resp?.status === 200 && resp?.data?.statusCode === 200) {
                  console.log('Najva token sent successfully', resp?.data);
                }
              }
            });
          }
        }
      } catch (err) {
        console.error('Error getting Najva token', err);
      }
    };

    if (userInfo) {
      getUserId();
    }
  }, [userInfo, jwtToken]);

  return (
    <PushContext.Provider value={{}}>
      {children}
    </PushContext.Provider>
  );
};

export default PushContextProvider;
export const usePushContext = () => React.useContext(PushContext);
